<template>
  <VueDialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <el-form-item label="模板文件" prop="file">
        <upload-file v-model="dialogForm.file" suffix="zip"/>
      </el-form-item>
      <el-form-item label="模板名称" prop="name">
        <el-input v-model.trim="dialogForm.name" clearable maxLength="18"></el-input>
      </el-form-item>
      <el-form-item label="模板描述" prop="remark">
        <el-input v-model.trim="dialogForm.remark" clearable></el-input>
      </el-form-item>
    </el-form>
  </VueDialog>
</template>

<script>
  import {inputEmpty,changeEmpty,checkNickName} from "@utils/validate"
  import UploadFile from "@view/components/upload/UploadFile"
  export default {
    name: "UploadTemplate",
    props: {dialogData: Object},
    components: {UploadFile},
    data() {
      return {
        dialogForm: {
          file: null,
          name: "",
          remark: "",
        },
        rules: {
          file: [changeEmpty("模板文件")],
          name: [inputEmpty("模板名称"),checkNickName()],
        }
      }
    },
    methods: {
      confirm() {
        this.$refs['dialogForm'].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.uploadPortalTemplate(nv, {}, true);
            if (res) {
              this.msgSuccess("上传成功");
              this.dialogData.visible = false;
              this.$emit("table-reload");
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
